var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8024 8.21884C15.5107 7.92705 15.0489 7.92705 14.7815 8.21884L12.0106 10.9909L9.26394 8.21884C8.97226 7.92705 8.51044 7.92705 8.24307 8.21884C7.95139 8.51064 7.95139 8.97264 8.24307 9.24012L10.9897 12.0122L8.21876 14.7599C7.92708 15.0517 7.92708 15.5137 8.21876 15.7812C8.3646 15.9271 8.55905 16 8.7292 16C8.89934 16 9.0938 15.9271 9.23963 15.7812L12.0106 13.0334L14.7572 15.7812C14.9031 15.9271 15.0975 16 15.2677 16C15.4378 16 15.6323 15.9271 15.7781 15.7812C16.0698 15.4894 16.0698 15.0274 15.7781 14.7599L13.0315 12.0122L15.7781 9.26444C16.0698 8.97264 16.0698 8.51064 15.8024 8.21884Z",
    fill: "#9BA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCross);
export default __webpack_public_path__ + "static/media/smallCross.a696a0ebdf237d6f4324d32aaa654a79.svg";
export { ForwardRef as ReactComponent };